export const MARKER_DATA_UPDATED = 'MARKER_DATA_UPDATED';

const markerDataUpdated = markerData => {
  return (dispatch) => {
    dispatch({
			type: MARKER_DATA_UPDATED,
			...markerData
    });
  };
};

export { markerDataUpdated };